<template>

  <!-- Page Block Buttons -->
  <div
    v-if="hasContent"
    class="page-block-buttons">

    <universal-link
      :key="button.id"
      :to="button.link"
      v-for="button in value"
      class="page-block-buttons__button"
      :target="button.targetBlank && '_blank'">

      <q-btn
        no-caps
        rounded
        color=""
        unelevated
        :size="size"
        text-color="primary"
        :style="buttonStyle(button)"
        :class="buttonClasses(button)">
        {{ button.label.ru }}
      </q-btn>

    </universal-link>

  </div>

</template>

<script>

  export default {
    name: 'page-block-buttons',
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      size: {
        type: String,
        default: '',
      },
    },
    computed: {
      hasContent() {

        return this.value
          && this.value.length;
      },
    },
    methods: {
      buttonStyle(button) {

        return {
          color: (button.textColor || 'white') + ' !important',
          backgroundColor: button.bgColor || 'white',
        };
      },
      buttonClasses(button) {

        const classes = [
          `${this.size}-size`,
        ];

        if (!button.bgColor)
          classes.push('bg-brand-gradient');

        return classes;
      },
    },
  };

</script>

<style lang="scss">

  .page-block-buttons {
    color: inherit;
    margin: -$spacer-ss;

    &__button {
      padding: $spacer-ss;
      text-decoration: none !important;
    }

    &__button button {
      align-items: center;
      display: inline-flex;
      justify-content: center;
    }

    &__button .q-btn {
      font-weight: bold;
      letter-spacing: 1px;
    }

    &__button .sm-size .q-btn__content {
      font-size: .9rem;
    }

    &__button .xs-size .q-btn__content {
      font-size: .8rem;
    }
  }

</style>
